import { Box, Stack, SxProps, TextField, Theme, Typography, useTheme } from '@mui/material';
import { grey, red } from '@mui/material/colors';

type ValueFieldProps = {
  label?: string;
  value: string | number | null;
  sx?: SxProps<Theme>;
  textFieldSx?: SxProps<Theme>;
  errorColor?: boolean;
};

export default function InfoTotalValue({ label, value, sx, textFieldSx, errorColor = false }: ValueFieldProps) {
  const theme = useTheme();

  const numericValue = Number(
    String(value)
      .replace(/[^\d.-]/g, '')
      .replace(',', '.'),
  );

  return (
    <Box sx={sx}>
      <Stack
        direction="row"
        sx={{
          width: '100%',
          display: 'flex',
          gap: 2,
          alignItems: 'center',
        }}
      >
        {label ? (
          <Typography variant="fieldHeader" sx={{ mt: 1 }} width={theme.spacing(15)}>
            {label}
          </Typography>
        ) : (
          <Box sx={{ width: theme.spacing(2), mt: 1 }} />
        )}
        <TextField
          sx={{
            flexGrow: 1,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              '& fieldset': {
                border: 'none',
              },
            },
            ...(errorColor && {
              '& .MuiInputBase-input': {
                color: numericValue === 0 ? grey[900] : red[600],
                WebkitTextFillColor: numericValue === 0 ? grey[900] : red[600],
              },
            }),
            ...textFieldSx,
          }}
          size="small"
          value={value ?? ''}
          disabled
        />
      </Stack>
    </Box>
  );
}
